var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isVisible
    ? _c(
        "div",
        { class: _vm.classes },
        [
          _c(
            "custom-select-field",
            _vm._b(
              {
                attrs: {
                  small: _vm.small,
                  placeholder: _vm.dynamicPlaceholderText,
                  "data-qa": `filtersbox-field:${_vm.displayName}`,
                },
              },
              "custom-select-field",
              { ..._vm.$attrs, ..._vm.$props },
              false
            ),
            _vm._l(_vm.options, function (val, name) {
              return _c(
                "div",
                { key: "multi-select-filter-item-" + val },
                [
                  _c("checkbox-field", {
                    attrs: {
                      value: _vm.value,
                      "display-name": name,
                      "checked-value": val,
                      inline: true,
                      condensed: true,
                      "data-qa": `multiselect-filter-checkbox:${name}`,
                    },
                    on: { input: _vm.onInput },
                  }),
                ],
                1
              )
            }),
            0
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }